const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let pageviewTracked = false;

export function trackPageView(page = "home") {
  if (pageviewTracked) return;
  pageviewTracked = true;
  fetch(`${API}/analytics/pageview`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      page,
      referrer: document.referrer || "",
      user_agent: navigator.userAgent || "",
    }),
  }).catch(() => {});
}

export function trackProductClick(productId, action = "view") {
  fetch(`${API}/analytics/click/${productId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ product_id: productId, action }),
  }).catch(() => {});
}
